"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertSlate = void 0;
var domhandler_1 = require("domhandler");
var domutils_1 = require("domutils");
var html_entities_1 = require("html-entities");
var slate_1 = require("slate");
var default_1 = require("../config/default");
var domhandler_2 = require("./domhandler");
var _1 = require(".");
var _2 = require(".");
var convertSlate = function convertSlate(_ref) {
  var node = _ref.node,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? default_1.config : _ref$config,
    _ref$isLastNodeInDocu = _ref.isLastNodeInDocument,
    isLastNodeInDocument = _ref$isLastNodeInDocu === void 0 ? false : _ref$isLastNodeInDocu,
    customElementTransforms = _ref.customElementTransforms,
    _ref$transformText = _ref.transformText,
    transformText = _ref$transformText === void 0 ? function (text) {
      return text;
    } : _ref$transformText,
    _ref$transformElement = _ref.transformElement,
    transformElement = _ref$transformElement === void 0 ? function (element) {
      return element;
    } : _ref$transformElement,
    _ref$wrapChildren = _ref.wrapChildren,
    wrapChildren = _ref$wrapChildren === void 0 ? function (children) {
      return new domhandler_1.Document(children);
    } : _ref$wrapChildren;
  if (slate_1.Text.isText(node)) {
    var str = config.alwaysEncodeBreakingEntities && !config.encodeEntities ? (0, _1.encodeBreakingEntities)(node.text) : node.text;
    var strLines = config.convertLineBreakToBr ? str.split('\n') : [str];
    var textChildren = [];
    // convert line breaks to br tags
    strLines.forEach(function (line, index) {
      var markElements = [];
      var markTransformKeys = (0, _2.intersection)(config.markTransforms || {}, node);
      markTransformKeys.forEach(function (key) {
        var _a;
        if ((_a = config.markTransforms) === null || _a === void 0 ? void 0 : _a[key]) {
          var markElement = config.markTransforms[key]({
            node: node,
            attribs: {}
          });
          if (markElement) {
            markElements.push(markElement);
          }
        }
      });
      Object.keys(config.markMap).forEach(function (key) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (node[key]) {
          var elements = config.markMap[key].map(function (tagName) {
            var _a;
            if ((_a = config.markTransforms) === null || _a === void 0 ? void 0 : _a[tagName]) {
              return config.markTransforms[tagName]({
                node: node,
                attribs: {}
              });
            }
            return new domhandler_1.Element(tagName, {}, []);
          }).filter(function (element) {
            return element !== undefined;
          });
          markElements.push.apply(markElements, _toConsumableArray(elements));
        }
      });
      // clone markElements (it gets modified)
      var markElementsClone = [].concat(markElements);
      var textElement = (0, domhandler_2.nestedMarkElements)(markElements, new domhandler_1.Text(line));
      if (config.alwaysEncodeCodeEntities && !config.encodeEntities && (0, domhandler_1.isTag)(textElement) && (0, domutils_1.getName)(textElement) === 'pre') {
        if (config.alwaysEncodeBreakingEntities) {
          // revert the earlier encoding - encode will re-encode
          line = (0, _1.decodeBreakingEntities)(line);
        }
        textChildren.push((0, domhandler_2.nestedMarkElements)(markElementsClone, new domhandler_1.Text((0, html_entities_1.encode)(line))));
      } else {
        textChildren.push(textElement);
      }
      if (index < strLines.length - 1) {
        textChildren.push(transformElement(new domhandler_1.Element('br', {})));
      }
    });
    return wrapChildren(textChildren.map(function (child) {
      return transformText(child);
    }));
  }
  var children = node.children ? node.children.map(function (n) {
    return (0, exports.convertSlate)({
      node: n,
      config: config,
      customElementTransforms: customElementTransforms,
      transformText: transformText,
      transformElement: transformElement,
      wrapChildren: wrapChildren
    });
  }) : [];
  var attribs = {};
  if (config.elementAttributeTransform) {
    attribs = Object.assign(Object.assign({}, attribs), config.elementAttributeTransform({
      node: node
    }));
  }
  var element = null;
  // more complex transforms
  if (customElementTransforms && customElementTransforms[node.type]) {
    element = customElementTransforms[node.type]({
      node: node,
      attribs: attribs,
      children: children
    });
  } else if (config.elementTransforms[node.type]) {
    element = transformElement(config.elementTransforms[node.type]({
      node: node,
      attribs: attribs,
      children: children
    }));
  }
  // straightforward node to element mapping
  if (!element && config.elementMap[node.type]) {
    element = transformElement(new domhandler_1.Element(config.elementMap[node.type], attribs, children));
  }
  // default tag
  if (!element && config.defaultTag && !node.type) {
    element = transformElement(new domhandler_1.Element(config.defaultTag, {}, children));
  }
  if (element) {
    return element;
  }
  // add line break between inline nodes
  if (config.convertLineBreakToBr && !isLastNodeInDocument) {
    children.push(transformElement(new domhandler_1.Element('br', {})));
  }
  return wrapChildren(children);
};
exports.convertSlate = convertSlate;